
export class MessageDisplayModel {

  public isDisplayingMessage: boolean = false;
  public text: string;
  public type: string;

  constructor(isDisplayingMessage = false, text = '', type = 'passive') {
    this.isDisplayingMessage = isDisplayingMessage;
    this.text = text;
    this.type = type;
  }
}
